// مركز تقارير مسار: الجدارات والفجوات والخطط والشهادات — عبر المعالج الموحد
import ReportWizard, { Sel, UnitCascade, EmployeePicker } from "@/v2/components/ReportWizard";
import { TYPE_AR } from "@/masar/lib";

const KINDS = [
  ["full", "تقرير شامل", "يجمع جميع المحاور ذات الصلة داخل نطاق صلاحيتك بمستوى التفصيل الذي تختاره."],
  ["custom", "تقرير مخصص", "تحدد الموضوع والنطاق والمحاور ومستوى التفصيل — مثل تقرير جدارة أو إدارة أو موظف."],
];

const scope = ({ f, setF, opt }) => {
  const set = (k) => (v) => setF({ ...f, [k]: v });
  const comps = (opt.competencies || []).filter((c) => !f.competency_type || c.type === f.competency_type);
  return (
    <>
      <UnitCascade units={opt.units || []} unitId={f.unit_id} onChange={set("unit_id")} />
      <Sel label="المسار الوظيفي" value={f.track_id} onChange={set("track_id")} options={(opt.tracks || []).map((t) => ({ value: t.id, label: t.name }))} testId="rf-track" />
      <Sel label="المسمى / المستوى الوظيفي" value={f.title_norm} onChange={set("title_norm")} options={(opt.titles || []).map((t) => ({ value: t.norm, label: t.title }))} testId="rf-title" />
      <Sel label="نوع الجدارة" value={f.competency_type} onChange={(v) => setF({ ...f, competency_type: v, competency_id: "" })} options={Object.entries(TYPE_AR).map(([k, l]) => ({ value: k, label: l }))} testId="rf-ctype" />
      <Sel label="الجدارة" value={f.competency_id} onChange={set("competency_id")} options={comps.map((c) => ({ value: c.id, label: `${c.type_ar} · ${c.name}` }))} testId="rf-comp" />
      <Sel label="المستوى المطلوب" value={f.target_level} onChange={set("target_level")} options={(opt.levels || []).map((l) => ({ value: l.key, label: `${l.key} · ${l.label}` }))} testId="rf-level" />
      <EmployeePicker employees={opt.employees} value={f.user_id} onChange={set("user_id")} />
    </>
  );
};

const chips = (opt, f) => {
  const out = [];
  const u = (opt.units || []).find((x) => x.id === f.unit_id); if (u) out.push(`${u.kind_ar}: ${u.name}`);
  const t = (opt.tracks || []).find((x) => x.id === f.track_id); if (t) out.push(`المسار: ${t.name}`);
  const ti = (opt.titles || []).find((x) => x.norm === f.title_norm); if (ti) out.push(`المسمى: ${ti.title}`);
  if (f.competency_type) out.push(`نوع الجدارة: ${TYPE_AR[f.competency_type]}`);
  const c = (opt.competencies || []).find((x) => x.id === f.competency_id); if (c) out.push(`الجدارة: ${c.name}`);
  if (f.target_level) out.push(`المستوى المطلوب: ${f.target_level}`);
  const emp = (opt.employees || []).find((x) => x.id === f.user_id); if (emp) out.push(`موظف: ${emp.name}`);
  return out;
};

export default function MasarReports() {
  return (
    <ReportWizard title="مركز التقارير" testId="masar-reports" storageKey="masar-report-job"
      sub="تقارير PDF بالهوية الموحدة من مصدر الحساب نفسه الذي تعرضه اللوحة"
      optionsUrl="/masar/admin/reports/options" jobsUrl="/masar/admin/reports/jobs" fileBase="/api/masar/admin/reports/jobs"
      renderScope={scope} chips={chips} sections={(opt) => opt.sections || []} kinds={KINDS}
      fullDesc="التقرير الشامل يضم كل المحاور داخل نطاق صلاحيتك: الملخص، الهيكل والتوزيع، الجدارات، الفجوات، الخطط والبرامج، مؤشرات الإدارة، الشهادات، العروض، (تفاصيل الموظفين بحسب مستوى التفصيل) ودليل القراءة." />
  );
}
